import {ThemeProvider, createTheme} from '@mui/material'
import {StyledDatePicker} from './Styles'
import PropTypes from 'prop-types'
import {useRef} from 'react'

const datePickerTheme = (theme) =>
  createTheme({
    ...theme,
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: theme.palette.common.black2,
            color: theme.palette.common.white
          }
        }
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            background: theme.palette.common.black2,
            color: theme.palette.common.white,
            fontSize: '14px',
            height: '40px'
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            color: theme.palette.common.lightGrey
          }
        }
      },
      MuiPickersYear: {
        styleOverrides: {
          yearButton: {
            fontSize: '14px'
          }
        }
      },
      MuiPickersMonth: {
        styleOverrides: {
          monthButton: {
            fontSize: '14px'
          }
        }
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            color: theme.palette.common.white
          }
        }
      },
      MuiDayCalendar: {
        styleOverrides: {
          weekDayLabel: {
            color: theme.palette.common.darkGrey,
            fontWeight: '600'
          }
        }
      }
    }
  })

const CustomDatePicker = ({
  value,
  onChange,
  minDate,
  disabled = false,
  format = 'DD/MM/YYYY',
  views = ['year', 'month', 'day']
}) => {
  const dateRef = useRef(null)
  return (
    <ThemeProvider theme={datePickerTheme}>
      <StyledDatePicker
        inputRef={dateRef}
        minDate={minDate}
        disabled={disabled}
        value={value}
        onChange={onChange}
        format={format}
        views={views}
        slotProps={{
          field: {clearable: true, onClear: () => dateRef?.current?.focus()}
        }}
      />
    </ThemeProvider>
  )
}

CustomDatePicker.propTypes = {
  value: PropTypes.any,
  disabled: PropTypes.bool,
  minDate: PropTypes.any,
  onChange: PropTypes.func,
  format: PropTypes.string,
  views: PropTypes.array
}

export default CustomDatePicker
